import { mergeLogOptions } from './errors';
import { TimeoutError } from './errors/TimeoutError';
import { SafeLogErrorOptions } from './log-error';

export const timeoutFactory = (ms: number, loggerFields: SafeLogErrorOptions) => {
    return new Promise((_, reject) => {
        setTimeout(() => {
            reject(new TimeoutError(mergeLogOptions(loggerFields, { additional: { timeoutTime: ms } })));
        }, ms);
    });
};
